var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RepaymentHead'),_c('div',{staticClass:"repayment-context"},[_c('el-table',{staticStyle:{"width":"100%","font-weight":"888"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{staticClass:".el-table-column",staticStyle:{"width":"30%"},attrs:{"prop":"name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }